import type { OfferedProjectType } from "../../../../clients/graphqlTypes.js";

// MEIS-11839: project-type set surfaced by the offered-services UI flows
// (onboarding tile grid, specify-matrix columns, settings checkboxes).
// Excludes OTHER, whose semantic ("this org offers OTHER for that category")
// is implicit in the presence of an organisation_categories row.
export const OFFERED_PROJECT_TYPES: OfferedProjectType[] = [
  "NEW",
  "REPAIR",
  "RENOVATION",
  "MAINTENANCE",
  "DIY",
];
